module.exports = __webpack_public_path__ + "static/media/marketing.eb399488.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/marketing.png
// module id = 498
// module chunks = 0